import * as types from '../dashboardActionTypes';

export default function securityAlertsLastMonthLoadingReducer(state = true, action) {
    switch(action.type) {
        case types.LOAD_SECURITY_ALERTS_FOR_LAST_MONTH:
            return true;
        case types.LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS:
        case types.LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/securityAlertsLastMonthLoadingReducer.js